<div class="header" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="center center">
    <img width="40px" src={{iconUrl}} alt="Icona incidència">
    <span class="title"> {{ description }}</span>
</div>

<img class="minimap" src="{{imageUrl}}" fxShow="true" fxHide.lt-sm="true">

<div class="content">
    

    <div>
        <span class="detail-name" i18n>Tipo:</span> {{type}}
    </div>

    <div>
        <span class="detail-name" i18n>Límite de velocidad:</span> {{ speed }} km/h
    </div>

    <div *ngIf="direction">
        <span class="detail-name" i18n>Dirección:</span> {{direction}}
    </div>
</div>




